const tPath = "settings.map.tabs.main";

export default tPath;
